
export default {
  name: 'BaseContent',
  props: {
    content: {
      type: Object,
      default: null,
    },
    blockClasses: {
      type: String,
      default: null,
    },
  },
  mounted() {
    this.content?.blocks?.forEach((block) => {
      if (block.data?.text) {
        const re = /<a\s+href=/gi

        const subst =
          '<a target="_blank" rel="noopener noreferrer nofollow" href='
        block.data.text = block.data.text.replace(re, subst)
      }
    })
  },
}
